/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateBulkSigningInput = {
    id: string;
    clientMutationId?: string | null;
};
export type createBulkSigningMutationVariables = {
    input: CreateBulkSigningInput;
};
export type createBulkSigningMutationResponse = {
    readonly createBulkSigning: {
        readonly bulkSigning: {
            readonly id: string;
        } | null;
        readonly presignedPostUrl: string | null;
    } | null;
};
export type createBulkSigningMutation = {
    readonly response: createBulkSigningMutationResponse;
    readonly variables: createBulkSigningMutationVariables;
};



/*
mutation createBulkSigningMutation(
  $input: CreateBulkSigningInput!
) {
  createBulkSigning(input: $input) {
    bulkSigning {
      id
    }
    presignedPostUrl
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBulkSigningPayload",
    "kind": "LinkedField",
    "name": "createBulkSigning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BulkSigningType",
        "kind": "LinkedField",
        "name": "bulkSigning",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "presignedPostUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createBulkSigningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createBulkSigningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3fcb67d1be62861746b4f66fcbdc66fe",
    "id": null,
    "metadata": {},
    "name": "createBulkSigningMutation",
    "operationKind": "mutation",
    "text": "mutation createBulkSigningMutation(\n  $input: CreateBulkSigningInput!\n) {\n  createBulkSigning(input: $input) {\n    bulkSigning {\n      id\n    }\n    presignedPostUrl\n  }\n}\n"
  }
};
})();
(node as any).hash = '95f2487ff8d5660d7737618a827b37ca';
export default node;
